import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-canvas',
  templateUrl: './canvas.component.html',
  styleUrls: ['./canvas.component.scss'],
})
export class CanvasComponent implements OnInit, OnDestroy {
  @ViewChild('canvasElement', { static: true })
  canvasElement?: ElementRef;

  @Input()
  width = '400';

  @Input()
  height = '200';

  @Output()
  readonly end = new EventEmitter<any>();

  private readonly subscriptions: Subscription[] = [];
  private signaturePad?: SignaturePad;

  constructor() {}

  ngOnInit(): void {
    if (this.canvasElement?.nativeElement instanceof HTMLCanvasElement) {
      this.signaturePad = new SignaturePad(this.canvasElement.nativeElement, {
        backgroundColor: '#ffffff',
        penColor: '#4c51f7',
      });
      this.signaturePad.onEnd = () => this.end.emit();
    }
  }

  ngOnDestroy(): void {
    while (this.subscriptions.length > 0) {
      this.subscriptions.pop()?.unsubscribe();
    }
  }

  getDrawing(): string {
    return this.signaturePad?.toDataURL() as string;
  }

  hasDrawing(): boolean {
    return !this.signaturePad?.isEmpty() || false;
  }

  loadDrawing(image: string): void {
    this.signaturePad?.fromDataURL(image);
  }

  reset(): void {
    if (this.signaturePad instanceof SignaturePad) {
      this.signaturePad.clear();
    }
  }
}
